import React, { createContext, useState, useContext, useCallback, useMemo } from 'react';

// 콘텐츠 관련 컨텍스트 생성
const ContentContext = createContext();

/**
 * 콘텐츠 데이터를 관리하는 Provider 컴포넌트
 */
export function ContentProvider({ children }) {
  // 상태 관리
  const [orderedContent, setOrderedContent] = useState([]);
  const [contentDetails, setContentDetails] = useState({});
  const [lastFetched, setLastFetched] = useState(null);

  // 콘텐츠 업데이트 함수
  const updateContent = useCallback((newOrderedContent, newContentDetails) => {
    if (newOrderedContent && newOrderedContent.length > 0) {
      setOrderedContent(newOrderedContent);
    }
    setContentDetails(prev => ({...prev, ...newContentDetails}));
    setLastFetched(new Date());
  }, []);

  // 캐시 초기화 함수
  const clearCache = useCallback(() => {
    setOrderedContent([]);
    setContentDetails({});
    setLastFetched(null);
  }, []);

  // 컨텍스트 값 메모이제이션
  const value = useMemo(() => ({
    orderedContent,
    contentDetails,
    lastFetched,
    updateContent,
    clearCache
  }), [orderedContent, contentDetails, lastFetched, updateContent, clearCache]);

  return (
    <ContentContext.Provider value={value}>
      {children}
    </ContentContext.Provider>
  );
}

/**
 * 콘텐츠 컨텍스트를 사용하기 위한 커스텀 훅
 */
export function useContent() {
  const context = useContext(ContentContext);
  if (!context) {
    throw new Error('useContent must be used within a ContentProvider');
  }
  return context;
} 
